import { combineEpics } from "redux-observable";
import submitForm from "./form/submitForm";

const rootEpic = combineEpics(
  submitForm,
);

export default rootEpic;
